

define(['angular', 'squid/index', 'text!./template.html', 'js/lib/index', 'components/xo-page-components/src/value-props/directive', '../lib/util'], function (angular, module, template) {

    return angular.module('xo-multistep-signup-address-normalization.directive', ['squid', 'xo-value-props.directive']).directive('xoMultistepSignupAddressNormalization', function ($rootScope) {

        return {
            template: template,

            scope: {
                id: '=',
                address: '=',
                doneFn: '='
            },

            controller: function controller($scope, $locale, $config) {}
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/multistep-signup/addressNormalization/directive.js
// module id = ./components/xo-guest-components/src/multistep-signup/addressNormalization/directive.js
// module chunks = 1